import { createFetcher } from '@composables/createFetcher';
import type { UserDetails } from '@modules/UserDetailsForm/UserDetails.interface';

type FanGetPayload = Record<string, never>;

type FanPatchPayload = UserDetails;

type FanSubscribePayload = {
  tierId: string;
};

type FanUnsubscribePayload = Record<string, never>;

type FanPushNotificationPayload = {
  endpoint: string;
  platform: string;
  auth: string;
  key: string;
};

type FanDeleteNotificationPayload = {
  auth: string;
  key: string;
};

export const useFanFetcher = () => {
  return {
    get: createFetcher<FanGetPayload>({
      endpoint: '/fan',
      method: 'GET',
      requiresAuth: true,
      requiresArtistId: true,
      payloadAsQuery: true,
    }),
    patch: createFetcher<FanPatchPayload>({
      endpoint: '/fan',
      method: 'PATCH',
      requiresAuth: true,
      requiresArtistId: true,
    }),
    subscribe: createFetcher<FanSubscribePayload>({
      endpoint: '/fan/subscribe',
      method: 'POST',
      requiresAuth: true,
    }),
    unsubscribe: createFetcher<FanUnsubscribePayload>({
      endpoint: '/fan/subscribe',
      method: 'DELETE',
      requiresAuth: true,
      requiresArtistId: true,
      payloadAsQuery: true,
    }),
    pushNotification: createFetcher<FanPushNotificationPayload>({
      endpoint: '/fan/push-notification',
      method: 'POST',
      requiresAuth: true,
      requiresArtistId: true,
    }),
    deleteNotification: createFetcher<FanDeleteNotificationPayload>({
      endpoint: '/fan/push-notification',
      method: 'DELETE',
      requiresAuth: true,
      requiresArtistId: true,
    }),
  };
};
